<div [formGroup]="followupForm">
    <div class="row mb-3 align-items-center">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_QUESTION_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-radio-input
                [(model)]="model.followupOptions"
                [parentForm]="followupFormChildren"
                id="radioFollowupOptions"
                (valueChange)="showHideControls()"
            >
            </pace-core-radio-input>
        </div>
    </div>
    <div class="row mb-3" *ngIf="showFollowUpAppointment">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_APPOINTMENT_LABEL"
        ></label>
        <div class="col-lg-8" *ngIf="!model.enableAppointmentBooking; else appointmentBooking">
            <pace-core-datetime-input
                [(model)]="model.appointmentTime"
                [parentForm]="followupFormChildren"
                [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_LABEL' | translate"
            ></pace-core-datetime-input>
        </div>
        <ng-template #appointmentBooking>
            <div class="col-xs-12 col-lg-2 pr-0 input-group w-auto">
                <pace-core-date-input
                    [(model)]="model.appointmentDate"
                    [datesEnabled]="datesEnabled$ | async"
                    [parentForm]="followupFormChildren"
                    [isDatePickerEnabled]="true"
                    (valueChange)="model.setAvailableSlots()"
                    [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_LABEL' | translate"
                >
                </pace-core-date-input>
                <div class="input-group-append">
                    <span class="btn btn-secondary form-control font-size-1" (click)="getAppointmentSlots()"
                        ><fa-icon [icon]="faCalendar"></fa-icon
                    ></span>
                </div>
            </div>
            <ng-container *ngIf="model.availableSlotsDropdownModel.value.length > 0">
                <label
                    class="col-lg-1 col-form-label text-lg-end text-start"
                    translate="CONFIRMATION_FOLLOWUP_ARRIVAL_SLOT_DROPDOWN_LABEL"
                ></label>
                <div class="col-xs-12 col-lg-3">
                    <pace-core-dropdown
                        [(model)]="model.availableSlotsDropdownModel"
                        [parentForm]="followupFormChildren"
                        (valueChange)="model.updateAppointmentTime()"
                    ></pace-core-dropdown>
                </div>
            </ng-container>
            <label
                class="col-lg-1 col-form-label text-lg-end text-start"
                translate="CONFIRMATION_FOLLOWUP_APPOINTMENT_TIME_LABEL"
            ></label>
            <div class="col-xs-12 col-lg-2">
                <pace-core-time-input
                    [(model)]="model.appointmentTime"
                    [parentForm]="followupFormChildren"
                    [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_TIME_LABEL' | translate"
                ></pace-core-time-input>
            </div>
        </ng-template>
    </div>
    <div class="row mb-3 align-items-center" *ngIf="showFollowUpAppointment">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_ADDITIONAL_TIME_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-duration-stepper
                id="durationStepper"
                name="durationStepper"
                [(model)]="model.additionalTime"
                [parentForm]="followupFormChildren"
                (valueChange)="resetAppointment()"
                [ariaLabel]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_TIME_LABEL' | translate"
            >
            </pace-core-duration-stepper>
        </div>
    </div>
    <div
        class="row mb-3 align-items-center"
        *ngIf="showFollowUpAppointment && model.followUpReasons && model.followUpReasons.value.length"
    >
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_REASON_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-dropdown
                [(model)]="model.followUpReasons"
                [parentForm]="followupFormChildren"
                id="dropdownFollowupReasons"
            ></pace-core-dropdown>
        </div>
    </div>

    <div class="row mb-3 align-items-center" *ngIf="showUMRCodeDropdown">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_CODE_GROUP_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-dropdown
                [(model)]="model.followUpUMRCodes"
                [parentForm]="followupFormChildren"
                id="dropdownComplaintsCodeGroup"
            ></pace-core-dropdown>
        </div>
    </div>

    <div
        class="row mb-3 align-items-center"
        *ngIf="showFollowUpAppointment && model.isForced && model.followupTextLong && model.followupTextLong.value"
    >
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_TEXT_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-text-input
                [(model)]="model.followupTextLong"
                [parentForm]="followupFormChildren"
                [ariaLabel]="'CONFIRMATION_FOLLOWUP_TEXT_LABEL' | translate"
            ></pace-core-text-input>
        </div>
    </div>

    <div class="row mb-3 align-items-center" *ngIf="model.additionalInfo && showFollowUpAppointment">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            translate="CONFIRMATION_FOLLOWUP_ADDITIONAL_INFORMATION_LABEL"
        ></label>
        <div class="col-lg-8">
            <pace-core-text-input
                [(model)]="model.additionalInfo"
                [parentForm]="followupFormChildren"
                [ariaLabel]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_INFORMATION_LABEL' | translate"
            ></pace-core-text-input>
        </div>
    </div>

    <!-- should be displayed only if No follow up required-->
    <ng-container *ngIf="isFollowUpSelectedNo">
        <div class="row mb-3" *ngIf="model.reasonsCode || model.reasonsCodeFallback">
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                translate="CONFIRMATION_EQUIPMENT_REASON_LABEL"
            ></label>
            <div class="col-lg-6" *ngIf="model.reasonsCode">
                <pace-core-tree-view
                    [(model)]="model.reasonsCode"
                    [parentForm]="followupFormChildren"
                ></pace-core-tree-view>
            </div>
            <!-- The following div is useful for debugging the selected entry-->
            <!--<div class="col-4" *ngIf="model.reasonsCode">
            Title: {{model.reasonsCode.selectedEntry ? model.reasonsCode.selectedEntry.value : ''}}<br>
            Group: {{model.reasonsCode.selectedEntry ? model.reasonsCode.selectedEntry.payload.codeGroup.value : ''}}
            </div>-->
            <div class="col-lg-4" *ngIf="model.reasonsCodeFallback">
                <pace-core-dropdown
                    [(model)]="model.reasonsCodeFallback"
                    [parentForm]="followupFormChildren"
                ></pace-core-dropdown>
            </div>
        </div>
        <ng-container
            *ngIf="
                model.reasonsCode &&
                model.reasonsCode.selectedEntry &&
                model.reasonsCode.selectedEntry.payload.codeGroup.value.indexOf(model.assayIndicator) === 0
            "
        >
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    translate="CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.assayNumber"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    translate="CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.lotNumber"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <!-- Legal check questions for Turkey -->
    <ng-container *ngIf="isFollowUpSelectedNo && model.showLegalCheckHandover">
        <div class="row mb-3 align-items-center">
            <label class="col-lg-2 col-form-label text-lg-end text-start">
                {{ model.legalCheckHandoverSafetyInformationText }}
            </label>
            <div class="col-lg-8">
                <pace-core-radio-input
                    [(model)]="model.legalCheckHandoverSafetyInformation"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-lg-2 col-form-label text-lg-end text-start">
                {{ model.legalCheckHandoverUserDocumentationText }}
            </label>
            <div class="col-lg-8">
                <pace-core-radio-input
                    [(model)]="model.legalCheckHandoverUserDocumentation"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
    </ng-container>
</div>
